import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("lp_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("lp_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };
  const signup = async (name, email, password) => {
    const res = await axios.post(`${API}/auth/signup`, { name, email, password });
    localStorage.setItem("lp_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };
  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`, {}); } catch {}
    localStorage.removeItem("lp_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, signup, logout, checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export const apiClient = axios.create({ baseURL: API });
apiClient.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("lp_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export { API };
